import styled from "styled-components";
import { breakpoints } from "../../../utils/styles";

const UserWalletCard = styled.div`
    img {
        margin: 0 auto;
        object-fit: fill;
        width: 100%;

        @media screen and (min-width: ${breakpoints.desktop}px) {
            max-width: 21rem;
        }
    }
`;

export default UserWalletCard;
